import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// Auth model: no JWT — we mirror the TotalCare pattern of caching the user
// object in localStorage after a successful /login.  Routes guard on the
// presence of that object; the server still verifies role via x-user-id.
//
// Additional rule: if `first_login` is true the user must change their
// temporary password before they're allowed anywhere else inside the app.
export default function ProtectedRoute({ children }) {
  const user = JSON.parse(localStorage.getItem("user") || "null");
  const location = useLocation();
  if (!user) return <Navigate to="/login" replace />;
  if (user.first_login && location.pathname !== "/first-login") {
    return <Navigate to="/first-login" replace />;
  }
  return children;
}
